<!--
  Le bouton « Encode » du mail du matin (section « APV de înregistrat »), le
  même partout où un APV n'a pas de réception d'achat (Chady, 2026-10-27).

  Il ouvre /apv-encode : on y charge le contrat, Claude le lit et prépare la
  réception, Florent la confirme. Même libellé et même vert que dans le mail.
  Avec `apv`, la page met cet APV en tête ; sans, elle montre toute la liste.
-->
<template>
  <vs-button size="small" color="#3d6b52" @click.stop="go">Encode</vs-button>
</template>

<script>
export default {
  name: 'HvEncodeButton',
  props: {
    apv: { type: String, default: '' }
  },
  methods: {
    go () {
      this.$router.push({ name: 'apv-encode', query: this.apv ? { apv: this.apv } : {} }).catch(() => {})
    }
  }
}
</script>
